module.exports = __webpack_public_path__ + "img/roule_img_03.6ad1d0ea.jpg";